import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import differenceInMinutes from 'date-fns/difference_in_minutes';

import store from 'Redux/store';
import { getOrders } from 'Redux/ducks/orders';
import Orders from 'Components/Order/Orders';
import OrderSearch from 'Components/Order/OrderSearch';

const OrderList = ({ orders, searchTerm, searchResults, ordersPerPage, authenticated }) => {
  useEffect(() => {
    store.dispatch(getOrders());
  }, [authenticated]);

  const filteredOrders = orders.filter((order) => {
    let updatedOrder = {};
    const currentDateTime = new Date();
    updatedOrder =
      ((['PENDING', 'INITIALISED'].includes(order.status) && differenceInMinutes(`${format(currentDateTime, 'YYYY-MM-DDTHH:mm:ss')}Z`, order.date) < 60)
      || !['PENDING', 'INITIALISED'].includes(order.status));
    return updatedOrder;
  });

  return (
    <React.Fragment>
      <OrderSearch />
      <Orders
        ordersPerPage={ordersPerPage}
        orders={filteredOrders}
        searchTerm={searchTerm}
        searchResults={searchResults}
      />
    </React.Fragment>
  );
};

OrderList.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({})),
  searchResults: PropTypes.arrayOf(PropTypes.object),
  searchTerm: PropTypes.string,
  ordersPerPage: PropTypes.number,
  authenticated: PropTypes.bool.isRequired,
};

OrderList.defaultProps = {
  orders: [],
  searchTerm: '',
  searchResults: [],
  ordersPerPage: 20,
};

const mapStateToProps = ({
  orders: { all, currentPage, searchResults, searchTerm }, auth: { authenticated },
}) => ({
  orders: all,
  currentPage,
  searchResults,
  searchTerm,
  authenticated,
});

export default connect(mapStateToProps)(OrderList);
